module.exports = __webpack_public_path__ + "static/media/dog-medium.178bcba1.svg";